const ENDPOINT = '/api/chat';

const MESSAGES_INIT = 'messages/MESSAGES_INIT';
const MESSAGES_SUCCESS = 'messages/MESSAGES_SUCCESS';
const MESSAGES_FAILED = 'messages/MESSAGES_FAILED';

const THREAD_ACTION_INIT = 'messages/THREAD_ACTION_INIT';
const THREAD_ACTION_SUCCESS = 'messages/THREAD_ACTION_SUCCESS';
const THREAD_ACTION_FAILED = 'messages/THREAD_ACTION_FAILED';

const THREADS_INIT = 'messages/THREADS_INIT';
const THREADS_SUCCESS = 'messages/THREADS_SUCCESS';
const THREADS_FAILED = 'messages/THREADS_FAILED';

const initialState = {
  data: {},
  loading: false
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case THREADS_INIT:
    case MESSAGES_INIT:
      return {
        data: initialState.data,
        loading: true
      };
    case THREADS_SUCCESS:
    case MESSAGES_SUCCESS: {
      return {
        data: action.payload,
        loading: false
      };
    }
    case THREADS_FAILED:
    case MESSAGES_FAILED:
      return {
        data: initialState.data,
        loading: false
      };
    default:
      return state;
  }
}

export function threads(data) {
  return {
    types: [THREADS_INIT, THREADS_SUCCESS, THREADS_FAILED],
    promise: (client) => client.post(`${ENDPOINT}/threads`, { data })
  };
}

export function messages(key, value) {
  return {
    types: [MESSAGES_INIT, MESSAGES_SUCCESS, MESSAGES_FAILED],
    promise: (client) => client.get(`${ENDPOINT}/${key}/${value}`)
  };
}

export function threadAction(threadId, data) {
  return {
    types: [THREAD_ACTION_INIT, THREAD_ACTION_SUCCESS, THREAD_ACTION_FAILED],
    promise: (client) => client.post(`${ENDPOINT}/thread/` + threadId, { data })
  };
}
